




































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ModalWrapper from '@/wrappers/ModalWrapper.vue';
import Button from '@/components/Button.vue';
import MaskedInput from 'vue-masked-input'
import http from '@/methods/http.ts';
import moment from 'moment';

@Component({
    components: {
        ModalWrapper,
        Button,
        MaskedInput
    }
})
export default class RegisterTimeModal extends Vue {
    @Prop(Boolean) opened: boolean;
    @Prop(Array) periods: any[];
    @Prop() specialist: any;
    @Prop() services: any;
    @Prop() date: any;
    @Prop() org: any;
    @Prop() live: boolean = false;
    @Prop() registrator: boolean = false;

    fullNameInput: string = '';
    phoneInput: string = '';
    isSmsNotificate = false

    @Watch('opened', {deep: true, immediate: true})
    onOpenedChange() {
        if (this.opened === false) {
            this.step = 1;
            this.fullNameInput = '';
            this.phoneInput = '';
            this.comment = '';
        }

    }
    onStateChanged() {
        this.step = 1;
    }

    get fullName() {
        //if (this.specialist.user === this.$store.state.profile.user_ptr_id) {
        if (this.registrator === true) {
            return '';
        } else {
            return this.$store.state.profile.full_name;
        }
    }

    get phone() {
        //if (this.specialist.user === this.$store.state.profile.user_ptr_id) {
        if (this.registrator === true) {
            return '';
        } else {
            return this.$store.state.profile.phone;
        }
    }

    get formattedDate() {
        return `${moment(this.date, 'DD.MM.YYYY').format('MM/DD/YYYY')} ${this.chosenPeriod.start}`;
    }

    dateToString(date) {
        return moment(date, 'DD.MM.YYYY').format('DD MMMM');
    }

    chosenService: any = {};
    chosenPeriod: any = {};
    comment: string = '';

    printData = {
        'id': '',
        'org': '',
        'service': '',
        'master_name': '',
        'price': '',
        'client_name': '',
        'comment': ''
    };

    PrintMe(elm) {
        var disp_setting="toolbar=yes,location=no,";
        disp_setting+="directories=yes,menubar=yes,";
        disp_setting+="scrollbars=yes,width=650, height=600, left=100, top=25";
        var content_vlue = document.getElementById(elm).innerHTML;
        var docprint=window.open("","",disp_setting);
        docprint.document.open();
        docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
        docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
        docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
        docprint.document.write('<head><title>My Title</title>');
        docprint.document.write('<style type="text/css">body{ margin:0px;');
        docprint.document.write('font-family:verdana,Arial;color:#000;');
        docprint.document.write('font-family:Verdana, Geneva, sans-serif; font-size:12px;}');
        docprint.document.write('a{color:#000;text-decoration:none;} </style>');
        docprint.document.write('</head><body onLoad="self.print()"><center>');
        docprint.document.write(content_vlue);
        docprint.document.write('</center></body></html>');
        docprint.document.close();
        docprint.focus();
    }

    createLiveReservation() {
        
        http(`masters/${this.specialist.slug}/reservation/create`, 'post', 'guest', {
            'service': this.chosenService.name,
            'price': this.chosenService.price,
            'master_name': this.org.owner,
            //'owner': this.org.owner,
            'client_name': this.fullNameInput,
            'reservation_time': moment().format('DD.MM.YYYY HH:mm'),
            'phone': this.phoneInput,
            'comment': this.comment,
            'duration': this.chosenService.duration,
            'street_address': this.org.street_address || this.specialist.street_address,
            'status': 'confirmed',
            'live': true
        }).then(r => {
            if (r.data.success === true) {
                console.group('createLiveReservation')
                console.groupEnd()
                this.printData.id = r.data.number;
                this.printData.master_name = this.specialist.full_name;
                this.printData.org = this.org.owner;
                this.printData.service = this.chosenService.name;
                this.printData.client_name = this.fullNameInput;
                this.printData.price = this.chosenService.price;

                this.step = 99;

                this.fullNameInput = '';
                this.phoneInput = '';
                this.comment = '';
                this.$emit('reservation-created');
                //this.$store.commit('notificate', { type: 'action', text: 'Спасибо, данное время забронировано' })
            }
        }).catch(error => {
            this.$store.commit('notificate', { text: error.response.data.message, type: 'error' });
        });
    }

    createReservation() {
        let token = '';
        let order_status = '';
        //if (this.$store.state.token && this.specialist.user !== this.$store.state.profile.user_ptr_id) {
        if (this.registrator === true) {
            token = 'guest';
            order_status = 'confirmed';
        } else {
            token = this.$store.state.token;
            order_status = 'armored';
        }
        const date = `${this.date} ${this.chosenPeriod.start}`
        const reservationDate = moment(date, 'DD.MM.YYYY HH:mm')
        http(`masters/${this.specialist.slug}/reservation/create`, 'post', token, {
            'service': this.chosenService.name,
            'price': this.chosenService.price,
            'master_name': this.org.owner, //this.specialist.full_name,
            //'owner': this.org.owner,
            'client_name': this.fullName || this.fullNameInput,
            'reservation_time': `${moment(this.date, 'DD.MM.YYYY').format('DD.MM.YYYY')} ${this.chosenPeriod.start}`,
            'phone': this.phone || this.phoneInput,
            'comment': this.comment,
            'duration': this.chosenService.duration,
            'street_address': this.org.street_address || this.specialist.street_address,
            'status': order_status,
            'alert_date': reservationDate.format('YYYY-MM-DD'),
            'alert_time': this.isSmsNotificate ? this.calculateTime(reservationDate) : ""
        }).then(r => {
            this.fullNameInput = '';
            this.phoneInput = '';
            this.isSmsNotificate = false;
            this.$emit('reservation-created');
            this.$store.commit('notificate', { type: 'action', text: 'Спасибо, данное время забронировано' })
        }).catch(error => {
            this.$store.commit('notificate', { text: error.response.data.message, type: 'error' });
        });
    }

    calculateTime(date) {
        return date.subtract({ hours: 1 }).startOf('hour').format('HH:mm')
    }

    step = 1;
}

